(function () {
  angular.module("akitabox.ui.dialogs.workOrder.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.workOrder",
    "akitabox.core.toast",
  ]);
})();
